import { SavingState } from '@common/Common';
import CorporateNavigation from '@common/Components/CorporateNavigation.vue';
import EditableValueSeriesSheet from '@common/Components/EditableValueSeriesSheet.vue';
import SaveButton from '@common/Components/SaveButton.vue';
import { KendoSpreadsheetColumn, KendoSpreadsheetValueSerie } from "@Kendo/Components/Spreadsheet/types";
import { ICommandBase } from '@Quest/cqrs';
import { UpdateResourceCapacitiesCommandV1 } from '@Quest/Resources/Domain/commands-core';
import ResourcesCommands from "@Quest/Resources/Domain/commands-vue-component";
import ResourcesQueries from "@Quest/Resources/Domain/queries-vue-component";
import { ResourceCapacityPageReadModel } from '@Quest/Resources/Domain/readmodels';
import Component, { mixins } from 'vue-class-component';
import { Route } from 'vue-router';


@Component({
    components: { CorporateNavigation, SaveButton, EditableValueSeriesSheet }
})
export default class ResourceCapacitiesPage extends mixins(ResourcesQueries, ResourcesCommands)
{
    get workspaceId() { return Number.parseInt(this.$route.params.workspaceId); }
    get strategyId() { return this.$route.params.strategyId; }
    get resourceId() { return this.$route.params.resourceId; }

    rm: ResourceCapacityPageReadModel | null = null;

    isEditing: boolean = false;
    savingState: SavingState = SavingState.Saved;

    get title(): string { return `${this.rm?.ResourceName}`; }
    get stopEditingLabel() { return this.savingState === SavingState.Pending ? "Cancel editing" : "Back"; }

    get inputSeries(): KendoSpreadsheetValueSerie[]
    {
        return this.rm!.Years.map(y => ({ Id: y.Year.toString(), Name: y.Year.toString(), Values: y.Values }));
    }

    get columns(): KendoSpreadsheetColumn[]
    {
        return [{ Label: "Jan" }, { Label: "Feb" }, { Label: "Mar" }, { Label: "Apr" }, { Label: "May" }, { Label: "Jun" }, { Label: "Jul" }, { Label: "Aug" }, { Label: "Sep" }, { Label: "Oct" }, { Label: "Nov" }, { Label: "Dec" }]
    }

    startEditing()
    {
        this.isEditing = true;
    }

    cancelEditing() 
    {
        if (this.savingState === SavingState.Saved) 
        {
            this.isEditing = false;
        }
        else if (this.savingState === SavingState.Pending && confirm("You have unsaved changes. Are you sure you want to cancel editing?")) 
        {
            this.savingState = SavingState.Saved;
            this.isEditing = false;
        }
    }

    onDataChange()
    {
        this.savingState = SavingState.Pending;
    }

    handleSaveCommand()
    {
        const entries = (this.$refs.sheet as any).getEntriesForSave();
        this.invokeUpdateResourceCapacitiesCommandV1(this.workspaceId, this.strategyId, this.resourceId, entries);
        this.savingState = SavingState.InProgress;
    }

    mounted()
    {
        document.title = "Resource | TransparentChoice";
        this.runResourceCapacityPageQueryV1(this.workspaceId, this.strategyId, this.resourceId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName === "ResourceCapacityPageReadModel")
        {
            this.rm = model as ResourceCapacityPageReadModel;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (UpdateResourceCapacitiesCommandV1.matchType(cmd))
        {
            this.runResourceCapacityPageQueryV1(this.workspaceId, this.strategyId, this.resourceId);

            if (this.savingState === SavingState.InProgress)
            {
                this.savingState = SavingState.Saved;
            }
        }
    }

    beforeRouteLeave(to: Route, from: Route, next: (arg?: any) => void) 
    {
        if (this.savingState === SavingState.Pending) 
        {
            if (confirm("You have unsaved changes. Do you want to save them before leaving?")) 
            {
                this.handleSaveCommand();
                next();
            }
            else 
            {
                next();
            }
        }
        else 
        {
            next();
        }
    }
}